import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

type AiMyprAutosize = boolean | { minRows?: number; maxRows?: number }


export default /*#__PURE__*/_defineComponent({
  __name: 'AiMyprPrQuestionsForm',
  props: {
    variant: { default: 'list' },
    good: null,
    bad: null,
    hobby: null,
    wanted: null,
    appeal: null,
    goodPlaceholder: null,
    badPlaceholder: null,
    hobbyPlaceholder: null,
    wantedPlaceholder: null,
    appealPlaceholder: null,
    goodAutosize: { type: [Boolean, Object] },
    badAutosize: { type: [Boolean, Object] },
    hobbyAutosize: { type: [Boolean, Object] },
    wantedAutosize: { type: [Boolean, Object] },
    appealAutosize: { type: [Boolean, Object] },
    goodMb10: { type: Boolean, default: true },
    showDigramToggle: { type: Boolean, default: false },
    useDigram: { type: Boolean, default: false }
  },
  emits: ["update:good", "update:bad", "update:hobby", "update:wanted", "update:appeal", "update:use-digram"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:good', value: string): void
  (e: 'update:bad', value: string): void
  (e: 'update:hobby', value: string): void
  (e: 'update:wanted', value: string): void
  (e: 'update:appeal', value: string): void
  (e: 'update:use-digram', value: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { variant: 'list' | 'qa', good: string, bad: string, hobby: string, wanted: string, appeal: string, goodPlaceholder?: string, badPlaceholder?: string, hobbyPlaceholder?: string, wantedPlaceholder?: string, appealPlaceholder?: string, goodAutosize?: AiMyprAutosize, badAutosize?: AiMyprAutosize, hobbyAutosize?: AiMyprAutosize, wantedAutosize?: AiMyprAutosize, appealAutosize?: AiMyprAutosize, goodMb10: boolean, showDigramToggle: boolean, useDigram: boolean };

/**
 * 書式 AI mypr の 4 質問フォーム（list / qa の 2 レイアウト）。
 */




const listDefaults = {
  goodPlaceholder: '丁寧に取り組むことができるなど',
  badPlaceholder: 'スケジュールがギリギリなど',
  hobbyPlaceholder: 'ヤギを数えること',
  wantedPlaceholder: 'ヤギを飼うこと',
  appealPlaceholder: 'ヤギに好かれること',
  goodAutosize: { minRows: 2, maxRows: 5 } as AiMyprAutosize,
  badAutosize: { minRows: 2, maxRows: 5 } as AiMyprAutosize,
  hobbyAutosize: { minRows: 3, maxRows: 5 } as AiMyprAutosize,
  wantedAutosize: { minRows: 3, maxRows: 10 } as AiMyprAutosize,
  appealAutosize: { minRows: 3, maxRows: 10 } as AiMyprAutosize
}

const qaDefaults = {
  goodPlaceholder: '',
  badPlaceholder: '',
  hobbyPlaceholder: '',
  wantedPlaceholder: '',
  appealPlaceholder: '',
  goodAutosize: true as AiMyprAutosize,
  badAutosize: true as AiMyprAutosize,
  hobbyAutosize: true as AiMyprAutosize,
  wantedAutosize: { minRows: 3, maxRows: 15 } as AiMyprAutosize,
  appealAutosize: { minRows: 3, maxRows: 15 } as AiMyprAutosize
}

const resolved = computed(() => {
  const base = props.variant === 'qa' ? qaDefaults : listDefaults
  return {
    goodPlaceholder: props.goodPlaceholder ?? base.goodPlaceholder,
    badPlaceholder: props.badPlaceholder ?? base.badPlaceholder,
    hobbyPlaceholder: props.hobbyPlaceholder ?? base.hobbyPlaceholder,
    wantedPlaceholder: props.wantedPlaceholder ?? base.wantedPlaceholder,
    appealPlaceholder: props.appealPlaceholder ?? base.appealPlaceholder,
    goodAutosize: props.goodAutosize ?? base.goodAutosize,
    badAutosize: props.badAutosize ?? base.badAutosize,
    hobbyAutosize: props.hobbyAutosize ?? base.hobbyAutosize,
    wantedAutosize: props.wantedAutosize ?? base.wantedAutosize,
    appealAutosize: props.appealAutosize ?? base.appealAutosize
  }
})

return { __sfc: true,props, emit, listDefaults, qaDefaults, resolved }
}

})